export default __webpack_public_path__ + "static/media/HH55555.d32f4a79.jpg";